module.exports = __webpack_public_path__ + "56c3eff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SubHeader/HeaderImage.png
// module id = 217
// module chunks = 0